import React, { memo } from 'react'
import { css } from 'styled-components/macro'
import { Box } from '@alobato/flex-box'
import Text from '@alobato/text'
import { Table, TableContainer, TableRow, TableCell, TableHeaderRow, TableHeaderCell } from '../../components/DataTable'
import { EmptyState } from '../../components/ui'
import MenuOver from '../../components/MenuOver'
import { MoreIcon } from '../../components/Icons'
import Pagination from '../../components/Pagination'

/* A API devolve 'F'/'M' (e, em registros legados, 'Feminino'/'Masculino').
   Antes só os valores por extenso eram tratados e a coluna ficava vazia. */
const mapGender = gender => {
  if (!gender) return '—'
  const value = String(gender).trim().toUpperCase()
  if (value === 'F' || value === 'FEMININO') return 'Feminino'
  if (value === 'M' || value === 'MASCULINO') return 'Masculino'
  return gender
}

const formatDateTime = text => {
  if (!text) return '—'
  const year = text.slice(0, 4)
  const month = text.slice(5, 7)
  const day = text.slice(8, 10)
  return `${day}/${month}/${year}`
}

const orDash = value => (value === null || value === undefined || value === '' ? '—' : value)

const List = ({ items, navigate, deleteItem, onPageChange, currentPage, pageCount }) => {

  const handleMenuOverClick = (action, id) => {
    switch (action) {
      case 'delete':
        deleteItem(id)
        break
      case 'show':
        navigate(`${id}`)
        break
      case 'edit':
        navigate(`${id}/editar`)
        break
      default:
        return false
    }
  }

  return (
    <>
      <Box mb={5}>
        {!!items.length ? (
          <TableContainer>
            <Table>
              <TableHeaderRow>
                <TableHeaderCell>Nome</TableHeaderCell>
                <TableHeaderCell>Sexo</TableHeaderCell>
                <TableHeaderCell>Email</TableHeaderCell>
                <TableHeaderCell>Dt. Nascimento</TableHeaderCell>
                <TableHeaderCell></TableHeaderCell>
              </TableHeaderRow>
              {items.map(item => (
                <TableRow key={item.id}>
                  <TableCell data-title='Nome'>{orDash(item.name)}</TableCell>
                  <TableCell data-title='Sexo'>{mapGender(item.gender)}</TableCell>
                  <TableCell data-title='Email'>{orDash(item.login)}</TableCell>
                  <TableCell data-title='Dt. Nascimento'>{formatDateTime(item.birth_date)}</TableCell>
                  <TableCell width={40} lineHeight={0}>
                    <MenuOver
                      options={[{label: 'Detalhes', value: 'show'}, {label: 'Editar', value: 'edit'}, {label: 'Excluir', value: 'delete'}]}
                      onSelect={action => handleMenuOverClick(action, item.id)}
                    >
                      <MoreIcon style={{cursor: 'pointer'}} />
                    </MenuOver>
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </TableContainer>
        ) : (
          <EmptyState />
        )}
      </Box>

      <Box ta='center'>
        <Pagination onPageChange={onPageChange} currentPage={currentPage} pageCount={pageCount} />
      </Box>
    </>
  )
}

export default memo(List)
